<template>
  <div class="orderItemBox">
    <slot>
      <van-row class="orderHeadRow">
        <slot name="headRow"> </slot>
      </van-row>
      <van-row class="orderIfnRow">
        <slot name="ifnRow"> </slot>
      </van-row>
      <div class="orderBottomRow">
        <slot name="bottomRow"> </slot>
      </div>
    </slot>
    <slot name="afterItem"></slot>
  </div>
</template>

<script>
import { reactive, toRefs } from 'vue'
import { useRouter } from 'vue-router'
import PlanInfCard from '@/components/order/PlanInfCard'
import BottomBtn from '@/components/order/BottomBtn'
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    active: {
      type: [Number, String],
      default: 0
    }
  },
  components: {},
  emits: ['click', 'clickBtn', 'clickDelete', 'refresh', 'hiddenCard', 'viewUseDealer'],
  setup(props, { emit }) {
    const router = useRouter()
    let {} = toRefs(props)
    const state = reactive({})
    return {
      ...toRefs(state)
    }
  }
}
</script>
<style lang="scss" scoped>
.orderItemBox {
  padding: 10px 0;
}
</style>
